import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material'
import React from 'react'

const ViewBadgeModal = ({ openDialog, handleCloseDialog, classes, selectedBadge }) => {
    return (
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth // Ensures the dialog uses the full width of maxWidth
            sx={{
                '& .MuiDialog-paper': {
                    width: '80%',
                    maxWidth: '400px',
                },
            }}>
            <DialogTitle style={{ fontSize: '20px', width: '200px', color: 'black' }}>
                Badge Details
            </DialogTitle>

            <DialogContent>
                <Typography variant="body1" sx={{ fontSize: '18px' }}>Title: <span style={{ fontWeight: 400 }}>{selectedBadge?.title}</span></Typography>
                <Typography variant="body1" sx={{ fontSize: '18px' }}>Category: <span style={{ fontWeight: 400 }}>{selectedBadge?.category}</span></Typography>
                <Typography variant="body1" sx={{ fontSize: '18px' }}>Description: <span style={{ fontWeight: 400 }}>{selectedBadge?.shortDescription}</span></Typography>
                <Typography variant="body1" sx={{ fontSize: '18px' }}>Logo:</Typography>
                <Box>
                    <img src={selectedBadge?.logo} alt="Category Logo" style={{ width: '100px', height: '100px' }} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button className={classes.cancelButton} onClick={handleCloseDialog}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ViewBadgeModal
